import { DashboardFiltersStore } from "@/features/esg-dashboard-v3/stores/filters.store";

// Target Setup Overview's own filters instance. Same store class as the
// dashboard, deliberately a separate singleton: the overview page seeds it
// from the dashboard's current values (and any drill-through URL params) on
// mount, and every later mutation stays local, so drilling into target
// setup can never rewrite the user's dashboard filters.
export const targetSetupFiltersStore = new DashboardFiltersStore();
